import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { Menu, Moon, Sun } from 'lucide-react';

import './NavBarComponent.css';
import { ROUTES_WITH_TITLES } from '../constants';
import uOttahackLogo from '../assets/uottahack8logo.png';
import { useDarkMode } from '../contexts/DarkModeContext';
import { RoutePath } from '../enums'; 

const NavBarComponent = () => {
    const [expanded, setExpanded] = useState(false);
    const { isDarkMode, toggleDarkMode } = useDarkMode();
    const [visibleRoutes, setVisibleRoutes] = useState(ROUTES_WITH_TITLES);

    useEffect(() => {
        const updateRoutes = () => {
            // Jan 16 at 10PM EST = Jan 17 at 3AM UTC (EST is UTC-5)
            const hackStartDate = new Date('2026-01-17T03:00:00Z');
            const now = new Date();
            const challengesVisible = now >= hackStartDate;

            const filtered = ROUTES_WITH_TITLES.filter(route => {
                if (route.path === RoutePath.Challenge) {
                    return challengesVisible;
                }
                return true;
            });

            setVisibleRoutes(filtered);
        };

        updateRoutes();
        const interval = setInterval(updateRoutes, 60000); // Check every minute
        return () => clearInterval(interval);
    }, []);

    return (
        <Navbar
            id="navbar-main"
            className={`navbar-dark ${expanded ? 'expanded' : ''}`}
            expanded={expanded}
            expand="xl"
            fixed="top"
        >
            <Container fluid className="px-3">
                <NavLink to="/" className="logo-link">
                    <img src={uOttahackLogo} alt="uOttaHack 8 Logo" className="logo" />
                </NavLink>

                {/* Dark Mode Toggle - Desktop (top right) */}
                <button
                    onClick={toggleDarkMode}
                    className="dark-mode-toggle desktop-toggle"
                    aria-label="Toggle dark mode"
                >
                    {isDarkMode ? <Sun size={24} /> : <Moon size={24} />}
                </button>

                {/* Hamburger Toggle */}
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={() => setExpanded(!expanded)}
                    className="hamburger-toggle"
                >
                    <Menu size={35} className="hamburger-icon" />
                </Navbar.Toggle>

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto">
                        {visibleRoutes.map((routeItem, index) => (
                            <NavLink
                                key={`route-path-link-${index}`}
                                to={Array.isArray(routeItem.path) ? routeItem.path[0] : routeItem.path}
                                exact
                                className="nav-link"
                                onClick={() => setExpanded(false)}
                            >
                                {routeItem.title}
                            </NavLink>
                        ))}
                    </Nav>
                    {/* Dark Mode Toggle - Mobile (bottom of menu) */}
                    <button
                        onClick={toggleDarkMode}
                        className="dark-mode-toggle mobile-toggle"
                        aria-label="Toggle dark mode"
                    >
                        {isDarkMode ? <Sun size={24} /> : <Moon size={24} />}
                        <span>{isDarkMode ? 'Light Mode' : 'Dark Mode'}</span>
                    </button>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavBarComponent;